<template>
  <div class="form_upload">
    <input type="file" style="display: none;" multiple ref="upload" @change="uploadChange()" />
    <div class="title">
      <p>{{ title }}</p>
    </div>
    <div class="upload_btn" :class="{ on: active }" @click="upload">
      {{ uploadText }}
    </div>
    <!-- <div class="example" v-show="example" @click="exampleBtn">示例</div> -->
    <div class="tip" v-show="tip" :style="{ color: color }" :title="tip">
      <span class="required">*</span>
      {{ tip }}
      <span class="tip_text" v-if="imgCls == 'XIV' && !isShowNav">请通过首页【下载预录入模版】下载《个人信息保护告知书》。</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    uploadFlag: {
      type: Boolean,
      default: true
    },
    uploadText: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    tip: {
      type: String,
      default: ""
    },
    active: {
      type: Boolean,
      default: false
    },
    example: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "#F94444"
    },
    imgCls: {
      type: String,
      default: ""
    },
    isShowNav: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    upload () {
      this.$emit("tipEvent");
      this.$refs.upload.value = "";
      if (this.uploadFlag) {
        this.$refs.upload.click();
      } else {
        this.$emit("uploadModal", []);
      }
    },
    uploadChange () {
      this.$emit("upload", this.$refs.upload.files);
    },
    refresh () {
      this.$refs.upload.value = "";
    },
    exampleBtn () {
      this.$emit("exampleFn");
    }
  }
};
</script>

<style scoped lang="less">
@import "~@/styles/less/variable.less";

.form_upload {
  height: 0.7rem;
  width: 5rem;
  position: relative;
  background: #f6f7f9;
  border: 0.5px solid #ebeef3;
  border-radius: 5px;
  margin-bottom: 0.24rem;
  font-size: 14px;
}
.upload_btn {
  width: 1.1rem;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  background: transparent;
  line-height: 0.7rem;
  text-align: center;
  color: #9a9a9a;
  border-radius: 5px;
  cursor: pointer;
  border: 1px solid #ebeef3;
}
.upload_btn.on {
  background: #d0aa72;
  color: #ffffff;
  border-right-color: transparent;
}
.title {
  padding-right: 1.34rem;
  padding-left: 0.16rem;
  width: 3.5rem;
  display: table-cell;
  box-sizing: content-box;
  height: 0.7rem;
  vertical-align: middle;
  line-height: 0.2rem;
  .fontsize-text-medium();
}
.example {
  position: absolute;
  right: -0.6rem;
  line-height: 1px;
  height: 1px;
  top: 50%;
  color: #d0aa72;
  cursor: pointer;
}
.example:hover {
  text-decoration: underline;
}
.tip {
  position: absolute;
  top: 0.7rem;
  left: 0;
  font-size: 12px;
  padding-left: 0.16rem;
  line-height: 0.28rem;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  .fontsize-text-small();
}
.tip .required {
  position: absolute;
  padding-right: 0.08rem;
  left: 0;
  top: 0;
  line-height: 0.06rem;
  top: 50%;
  font-size: 0.18rem;
}
.tip .tip_text {
  color: #9f9f9f;
  padding-left: .1rem;
}
@media screen and (max-width: 1440px) {
  .form_upload {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/imageNode/child/upload.vue